import {
  TechemModal,
  TechemModalBody,
  TechemModalButtonFooter,
  TechemModalHeader
} from '@techem/ui-components';
import warningIcon from '../../../../assets/icons/png/3x/icn-warning@3x.png';
import { TrackerUtil } from '../../../../../tracking/TrackerUtil';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface ErrorModalProps {
  error: string | null;
  setError: (error: string | null) => void;
}

const ErrorModal: FC<ErrorModalProps> = ({ error, setError }) => {
  const { t } = useTranslation();

  return (
    <TechemModal
      closeable
      isOpen={error !== null}
      modalTrackingId="modal-error"
      additionalTestId="error"
      header={
        <TechemModalHeader
          src={warningIcon}
          title={t('errorModalNoDataTitle')}
          titleAlignment="center"
        />
      }
      body={
        <TechemModalBody>
          <p className="text-center">{t('errorModalNoDataDescription')}</p>
        </TechemModalBody>
      }
      footer={
        <TechemModalButtonFooter
          primary={{
            text: t('closeModalText'),
            handleOnClick: () => setError(null),
            additionalTestId: 'close'
          }}
          trackClickUsingTestId={(buttonIdentifier) =>
            TrackerUtil.trackBtnClickByIdentifier(buttonIdentifier, 'modal-error')
          }
        />
      }
    />
  );
};

export default ErrorModal;
